import Layout from '../component/Layout/Layout'
import { Link } from 'react-router-dom'

export default function CustomTailoring() {
  
    return (
        <Layout title="Custom Tailoring:  Chaashni Couture" description="Chaashni Couture: Description" >
        <div className="how-it-works-box">
  <div className="home-full homegroth-wrap how-it-works-wrap">
    <div className="container center-text">
      <div className="center-text-box">
        <h2><span className="best-in-class">Best in Class</span>CUSTOM TAILORING</h2>
        <p>Over the last <strong>12 years</strong> we've delivered over 67,000 immaculately crafted <strong>'Made-to-Fit'</strong> dresses to over 20,000 customers across the globe.{/* <br />
           No matter which part of the globe you are in, you can confidently choose any dress from our collection and order it in your size.*/}</p>
        <p>This is a <strong>Simple 4 Step Process</strong>.</p>
      </div>
    </div>
  </div>
  <div className="home-full homegroth-wrap how-it-works-wrap-inner">
    <div className="container">
      <div className="three-steps">
        <div className="right-section">
          <ul>
            <li>
              <p><strong>Step 1:</strong></p>
              <p>Select a Dress. While selecting a size, <br />
                choose 'Custom Tailored'. It is available for most of the items.</p>
            </li>
            <li>
              <p><strong>Step 2:</strong></p>
              <p>Payment and Checkout.</p>
            </li>
            <li>
              <p><strong>Step 3:</strong></p>
              <p>Feed in your measurements in the "My Measurements" section. {/*<br /> <Link to="/measurements" target="_blank">Watch this video</Link> for help.*/}</p>
            </li>
            <li>
              <p><strong>Step 4:</strong></p>
              <p>We will stitch your ordered dress in your perfect measurement and ship it to you.</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div className="home-full homegroth-wrap  how-it-works-wrap-inner">
    <div className="container">
      <div className="center-text-box-1 content-box">
        <h2>TERMS AND CONDITION (Custom Tailored Orders)</h2>
        <ol>
          <li>REFUND POLICY: Custom Tailored Orders <strong>cannot be returned</strong>.</li>
          <li>
            <p>We would be delighted to customize this garment to your exact measurements.</p>
            <p>To place a ‘Custom Tailored’ order, please email us at <Link target="_blank" to="mailto:customercare@chaashnicouture.com">customercare@chaashnicouture.com</Link> or <Link target="_blank" to={`https://wa.me/+91919582475486?text=Hello%2C+I+have+a+query+regarding+custom+tailored`} className="custom-whatapp-icon">WhatsApp us</Link>. Kindly include the 'Item Code' (mentioned above) and your preferred delivery date in your message.</p>
            <p>Our delivery timeline for 'Custom Tailored' orders ranges from 3 to 8 weeks, depending on the complexity of the design. We will confirm the exact timeframe before officially accepting your order.</p>
            <p>If you require any additional customizations, please feel free to let us know. Kindly note that the garment price may vary based on the requested customizations or size adjustments.</p>
            <p>Once your 'Custom Tailored' order is placed, you will need to enter your measurements in the <Link target="_blank" to="/measurements">‘My Measurements’</Link> section. A helpful DIY video in that section will guide you through the process.</p>  
          </li>
          <li>Once the order is shipped, <strong>Domestic (Indian) deliveries</strong> take about 3-8 days while <strong>International Deliveries</strong> take about 5-15 days. A lot depends on the promptness of the courier partners.</li>
          <li>Very seldom do our customers require <strong>alterations</strong> after we stitch a dress to their size. If at all there are any alterations, it is recommended that you get them done at your nearby boutique. Please note that ChaashniCouture.com will not be liable to bear expenses of such alterations.</li>
          <li>ChaashniCouture.com reserves the right to cancel any Custom Order within 48 hours of receiving it. This may happen sometimes due to non-availability of fabric or other resources.</li>
        </ol>
      </div>
      <div className="center-text-box-1 content-box">
        <h2>MEASUREMENTS</h2>
        <p>Once you’ve placed the order, paid, and checked out, it is time to feed in your measurements by going to <Link to="/my-account" target="_blank">MY ACCOUNT</Link> &gt; <Link to="/measurements/" target="_blank"> MY MEASUREMENTS </Link>.</p>
      </div>
      <span id="video-box"></span>
      {/* <div className="center-text-box-1 content-box">
        <h2>HOW TO TAKE MEASUREMENTS</h2>
        <p>That's super easy. We've compiled a short video to explain <Link to="/measurements" target="_blank">How to take Your Measurements</Link>. It takes only 10 mins to do so. </p>
        <div className="video-box-video youtube-video-wrap">
          <div className="youtube-video-wrap"><img src="../images/youtube-img.jpg" alt="" />
            <iframe src="https://www.youtube.com/embed/sYt-m98__Vc?rel=0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="" width="560" height="315" frameborder="0"></iframe>
          </div>
        </div>
      </div> */}
      <div className="center-text-box-1 content-box">
        <h2>HELP</h2>
        <p style={{marginBottom:"0"}}>If you need further help, write to us on <Link to="mailto:customercare@chaashnicouture.com">customercare@chaashnicouture.com</Link> or <Link target="_blank" to="https://api.whatsapp.com/send?phone=919582475486" rel="noopener noreferrer" className="whatapp-icon whatapp-icon-inline"> Whatsapp us </Link>.</p>
      </div>
    </div>
  </div>
  <div className="home-full homegroth-wrap how-it-works-wrap-inner">
    <div className="container">
      <div className="google-wrap" target="_blank" style={{padding:"25px 0 0"}}>
        <Link to="https://tinyurl.com/2n7h2ddy" target="_blank"><img src="../images/Google-reviews2.png" alt="" /></Link>
      </div>
    </div>
  </div>
</div>
        </Layout>
    )
}